import styled from "styled-components";
import { PrimaryButton } from "./BaseButton";
import { SIDEMENU, MAINMENU } from "Framework/consts/menuTypes";
import React from "react";
import { MenuButtonIcons } from "Components/Menu/MenuButtonIcons";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { Minus, Svg } from "BaseComponents/Icons/Svg";

export const MenuButtonStyle = styled(PrimaryButton).attrs(({ Depth, MenuType, Expanded }) => ({}))`
	& {
		position: relative;
		border: ${({ theme }) => `2px solid ${theme.colors.primary}`};

		border-radius: 50%;
		color: #0e3c7c;
		font-size: 16px;
		margin: 5px 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		height: 20px;
		${media.lessThan(breakpoints.mobile)`

		${Svg} {
			width: 15px;
			height:15px;
			path {
				stroke-width: 4;
			}
		}
		`}
		background-color: ${({ theme }) => theme.colors.primary};
		transition: 0.2s ease;
		${media.lessThan(breakpoints.mobile)`
			width: 26px;
			height: 26px;
  		`}
		svg {
			transition: 0.2s ease;
			stroke: ${({ theme }) => theme.colors.white};
		}
		${media.greaterThan(breakpoints.mobile)`
		&:hover {
			background-color: white;
			i:before {
				color: black;
			}
			svg {
				stroke: ${({ theme }) => theme.colors.primary};
			}
		}
		`}
	}
`;

export const MenuButton = ({ IsExpanded, Depth, MenuType, ShouldAnimate, Width, onClick }) => {
	return (
		<MenuButtonStyle
			onClick={onClick}
			IsExpanded={IsExpanded}
			width={Width}
			Depth={Depth}
			MenuType={MenuType}
		>
			<MenuButtonIcons
				ShouldAnimate={ShouldAnimate}
				Depth={Depth}
				IsExpanded={IsExpanded}
			/>
		</MenuButtonStyle>
	);
};
